export const SET_LOADING = 'SET_LOADING'

export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS'
export const REGISTER_USER_ERROR = 'REGISTER_USER_ERROR'

export const SET_USER = 'SET_USER'
export const FETCH_JOBS_SUCCESS = 'FETCH_JOBS_SUCCESS'
export const FETCH_JOBS_ERROR = 'FETCH_JOBS_ERROR'
export const LOGOUT_USER = 'LOGOUT_USER'
export const CREATE_JOB_SUCCESS = 'CREATE_JOB_SUCCESS'
export const CREATE_JOB_ERROR = 'CREATE_JOB_ERROR'
export const DELETE_JOB_ERROR = 'DELETE_JOB_ERROR'
export const FETCH_SINGLE_JOB_SUCCESS = 'FETCH_SINGLE_JOB_SUCCESS'
export const FETCH_SINGLE_JOB_ERROR = 'FETCH_SINGLE_JOB_ERROR'

export const EDIT_JOB_SUCCESS = 'EDIT_JOB_SUCCESS'
export const EDIT_JOB_ERROR = 'EDIT_JOB_ERROR'
